import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#023e8a',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#cf3832',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        orange: '#E87630',
        estadoActivo: '#44af87',
        botonRefrescar: '#0369a1',
        verDetalles: '#26A69A',
        btnCancelar: '#d64848',
        btnAceptar: '#2a942b',
        btnLogin: '#e0e0e0',
      },
    },
  },
  lang: {
    locales: {
      es,
    },
    current: 'es',
  },
  icons: {
    iconfont: 'md',
  },
});
